import React from "react"
import { Snackbar, Slide, Alert, AlertColor } from "@mui/material"
import { CommonSnackbarProps } from "main/common/common_snackbar/CommonSnackBarTypes"

const styles = () => ({
  alertContainer: {
    width: "100%",
    padding: "8px,16px"
  }
})

const CommonSnackbar: React.FC<CommonSnackbarProps> = ({
  message,
  variant = "success",
  open,
  action = undefined,
  onClose,
  autoHideDuration = 3000,
  position = {
    vertical: "top",
    horizontal: "right"
  }
}) => {
  const classes = styles()
  return (
    <Snackbar
      anchorOrigin={position}
      onClose={onClose}
      open={open}
      onClick={action}
      TransitionComponent={Slide}
      autoHideDuration={autoHideDuration}
    >
      <Alert
        onClick={action}
        severity={variant as AlertColor}
        sx={classes.alertContainer}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}
export default CommonSnackbar
